<template>
  <section>
    <div class="row mb-3">
      <div class="col">
        <h4 class="form-head">Reconciliation</h4>
      </div>
    </div>
    <div class="row">
        <div class="col-8">
          <b-form-group label="Select GSTR1 Zip File(s)">
            <b-form-file
              v-model="file"
              multiple
              accept="application/zip"></b-form-file>
          </b-form-group>
        </div>
        <div class="col-auto align-right">
          <div class="mt-2">
            <button type="button" class="btn btn-primary mt-4" @click.prevent="reconcile()"
                    :disabled="status === 'STARTED'">
              <span v-if="status !== 'IDLE' && status !== 'COMPLETED'">Checking ... </span>
              <span v-if="status === 'IDLE' || status === 'COMPLETED'">Check</span>
            </button>
          </div>
        </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <div class="row pb-3" v-if="status === 'COMPLETED'">
          <div class="col-auto">
            <h4>Results</h4>
          </div>
          <div class="col-auto">
            <select class="form-control" v-model="stateName" @change="filterReport">
              <option value="">All States</option>
              <option v-for="st of stateNames" :key="st" :value="st">{{st}}</option>
            </select>
          </div>
          <div class="col-auto mt-2">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="ignoreURP" @change="filterReport">
              <label class="custom-control-label" for="customSwitch1">Ignore URP EWaybills</label>
            </div>
          </div>
          <div class="col-auto mt-2">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="customSwitch2" v-model="only50K" @change="filterReport">
              <label class="custom-control-label" for="customSwitch2">Only Value > 50K</label>
            </div>
          </div>
          <div class="col-auto">
            <select v-model="filterDoc" class="form-control" @change="filterReport">
              <option value="ALL">All Doc Types</option>
              <option value="INVOICE">Only Invoices</option>
              <option value="CREDIT_NOTE">Only Credit Notes</option>
              <option value="DEBIT_NOTE">Only Debit Notes</option>
              <option value="EXPORT">Only Export Invoices</option>
            </select>
          </div>
          <div class="col-auto">
            <select v-model="filter" class="form-control" @change="filterReport">
              <option value="NONE">Show All</option>
              <option value="MATCH">Show Only Correct Data</option>
              <option value="DATA_MISMATCH">Show Only Data Mismatch</option>
              <option value="INVOICE_MISSING">Show Only Unknown EWB Entries</option>
              <option value="EWB_MISSING">Show Only Invoices with no EWB</option>
              <option value="NO_PARTB">Show Only EWB with No-PartB</option>
              <option value="ONLY_PARTB">Show Only EWB with PartB</option>
            </select>
          </div>
          <div class="col-auto">
            <button class="btn btn-info" @click="downloadExcel()"><i class="fa fa-download"></i> Excel</button>
          </div>
        </div>
        <table class="table table-sm" v-if="status === 'COMPLETED'">
          <thead class="thead-dark">
          <tr>
            <th>&nbsp;</th>
            <th>Doc Type</th>
            <th>State</th>
            <th>Invoice Consignee GST</th>
            <th>Invoice No</th>
            <th>Invoice Dt</th>
            <th>Invoice Value</th>
            <th>E-Waybill No</th>
            <th>E-Waybill Consignee GST</th>
            <th>E-Waybill Invoice No</th>
            <th>E-Waybill Invoice Dt</th>
            <th>E-Waybill Invoice Value</th>
            <th>E-Waybill Validity</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(e, index) in reconciled" :key="e.docNo">
            <td>{{index+1}}</td>
            <td>{{e.docType}}</td>
            <td>{{e.state}}</td>
            <td>{{e.consigneeGst}}</td>
            <td>{{e.invoiceNo}}</td>
            <td>{{e.invoiceDt}}</td>
            <td>{{e.invoiceVal}}</td>
            <td>{{e.ewbNo}}</td>
            <td>{{e.ewbConsigneeGst}}</td>
            <td>{{e.ewbInvoiceNo}}</td>
            <td>{{e.ewbInvoiceDt}}</td>
            <td>{{e.ewbInvoiceVal}}</td>
            <td>{{e.ewbExpiryStr}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'
import _ from 'lodash'

export default {
  name: 'ReconcilePage',
  data () {
    return {
      creds: [],
      selectedCred: null,
      fileContent: '',
      consignorGst: '',
      csv: [],
      status: 'IDLE',
      ewaybills: [],
      invoices: [],
      reconciled: [],
      stateNames: [],
      stateName: '',
      ignoreURP: true,
      only50K: false,
      filter: 'DATA_MISMATCH',
      filterDoc: 'ALL',
      fromDate: new Date(),
      toDate: new Date(),
      file: [],
      requestId: null,
      gstNumber: null,
      fp: null
    }
  },
  filters: {
    toAmount (value) {
      return numeral(value).format('0,0.00')
    }
  },
  computed: {
  },
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (this.$store.state.loggedIn) {
        axios.get('/app/cred')
          .then(response => {
            this.creds = response.data
            this.selectedCred = this.creds[0].id
          }, error => {
            console.error('Error in Loading Creds', error)
          })
      } else {
        this.$router.push('/login')
      }
      console.log('start at', moment().format('yyyy-MM-dd'))
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
  },
  methods: {
    reconcile: function () {
      this.status = 'STARTED'
      let formData = new FormData()
      this.file.forEach((f, idx) => {
        formData.append(`file`, f)
      })
      formData.append('total', `${this.file.length}`)
      axios.post('/web-app/reconcile', formData).then(resp => {
        this.reconciled = _.flatMap(resp.data.results, 'items')
        this.requestId = resp.data.requestId
        this.stateNames = resp.data.stateNames
        this.status = 'COMPLETED'
      }, err => {
        console.error('error in reconcile', err)
        alert('error in file upload')
      })
    },
    downloadExcel: function () {
      window.open(`${process.env.API_URL}/web-app/reconcile?requestId=${this.requestId}&filter=${this.filter}&only50K=${this.only50K}&csv=true&x-auth-token=${this.$store.state.accessToken}&filterDocType=${this.filterDoc}`)
    },
    filterReport: function () {
      this.status = 'STARTED'
      axios.get(`/web-app/reconcile?requestId=${this.requestId}&filter=${this.filter}&stateName=${this.stateName}&ignoreURP=${this.ignoreURP}&only50K=${this.only50K}&filterDocType=${this.filterDoc}`).then(resp => {
        this.reconciled = _.flatMap(resp.data.results, 'items')
        this.status = 'COMPLETED'
      }, err => {
        console.error('error in re-concile', err)
        this.staus = 'COMPLETED'
      })
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/EWaybillReconcile.vue